const prefix = "app/ReportsV2/ClimateMeasurement"

export const GET_DIMENSIONS_DATA_WATCHER = `${prefix}/GET_DIMENSIONS_DATA_WATCHER`
export const GET_DIMENSIONS_DATA_SUCCESS = `${prefix}/GET_DIMENSIONS_DATA_SUCCESS`
export const GET_DIMENSIONS_DATA_FAILED = `${prefix}/GET_DIMENSIONS_DATA_FAILED`
